// ────────────────────────────────────────────────────────────────────────
// GroupNode — 多节点群组的"装饰矩形"
// ────────────────────────────────────────────────────────────────────────
// 这是一个纯展示型节点：浅蓝圆角矩形 + 左上角标签。
// 关联的子节点 id 存在 data.childIds 里；拖动联动和删除联动都在 EditorPage
// 的 onNodeDrag / onNodesDelete 中处理（不依赖 ReactFlow 的 parentNode 机制）。
// 群组自身 zIndex=-1，children zIndex>=10，确保 children 在视觉与事件上都在群组之上。

import React, { memo } from 'react';
import { Layers } from 'lucide-react';

const GroupNode = ({ data, selected }) => {
  const childCount = (data?.childIds || []).length;

  return (
    <>
      {/* 整框可点击 + 可拖（ReactFlow 默认行为） */}
      <div style={{
        width: '100%',
        height: '100%',
        backgroundColor: selected ? 'rgba(59, 130, 246, 0.16)' : 'rgba(59, 130, 246, 0.10)',
        border: selected ? '2px solid rgba(59, 130, 246, 0.7)' : '2px solid rgba(59, 130, 246, 0.25)',
        borderRadius: '14px',
        boxSizing: 'border-box',
        position: 'absolute',
        top: 0,
        left: 0,
        pointerEvents: 'all',
        cursor: 'grab',
      }} />

      {/* 标签 — 仅展示，pointerEvents:none 避免抢走整框的拖拽事件 */}
      <div style={{
        position: 'absolute',
        top: 8,
        left: 8,
        background: selected ? 'rgba(59, 130, 246, 0.9)' : 'rgba(59, 130, 246, 0.55)',
        padding: '4px 10px',
        borderRadius: '6px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        zIndex: 10,
        userSelect: 'none',
        pointerEvents: 'none',
      }}>
        <Layers size={13} />
        <span>{data?.label || '群组'} · {childCount}</span>
      </div>
    </>
  );
};

export default memo(GroupNode);
